import axios from 'axios';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import REACT_APP_API_URL from './ApiEnvironment';
import { useAuth0 } from '@auth0/auth0-react';
import { selectConfig } from '../Store/configSlice';
import { selectUserId } from '../Store/adminSlice';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../Store/store';
import { apiSlice, selectApi } from '../Store/apiSlice';

const useApi = () => {

    const apiConfig = useSelector(selectApi);
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();
    const config = useSelector(selectConfig);
    const userId = useSelector(selectUserId);
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {

        const initializeApi = async () => {
            
            if (!isAuthenticated) {
                return;
            }

            try {
                const token = await getAccessTokenSilently();
                const headers = {
                    'Authorization': `Bearer ${token}`
                };

                if (config?.admin && userId) {
                    headers['Impersonate'] = userId;
                }
                if (shouldUpdateApiConfig(apiConfig, { baseURL: REACT_APP_API_URL, headers })) {

                    dispatch(apiSlice.actions.setApi({
                        baseURL: REACT_APP_API_URL,
                        headers: headers
                    }));
                }

            } catch (error) {
                console.error('Error setting up API:', error);
            }
        };

        initializeApi();

    }, [isAuthenticated, config, userId, getAccessTokenSilently, dispatch, apiConfig]);

    const api = useMemo(() => {
        if (apiConfig) {
            return axios.create(apiConfig);
        } else {
            return null;
        }
    }, [apiConfig]);

    return api;
};

function shouldUpdateApiConfig(currentConfig, newConfig) {
    return JSON.stringify(currentConfig) !== JSON.stringify(newConfig);
}

export default useApi;
